export default __webpack_public_path__ + "static/media/figuremap66.b6ae73a2.png";